import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Row,
    Button,
} from "reactstrap";
import { getAnimeById, deleteAnimeComment } from "utils/endpoint";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { getUniverseSummaryById } from "utils/endpoint";
import UniverseModal from "utils/universeModal";
import useSearchParams from "utils/useSearchParams";
import { CSVLink } from "react-csv";
import { genrateCsvFileName } from "utils/Commen";

export const headers = [
    { label: "EN Title", key: "en_title" },
    { label: "Universe Name", key: "universe_name" },
    { label: "JP Publisher", key: "licensor" },
    { label: "Studio", key: "studio" },
    { label: "Studio Link", key: "studio_link" },
    { label: "No Of Episodes", key: "no_of_episodes" },
    { label: "Platforms", key: "platforms" },
    { label: "Ratings", key: "ratings" },
    { label: "Vod Link", key: "vod_link" },
    { label: "Rel. Date", key: "rel_date" },
    { label: "Rel. Date Precision", key: "rel_date_precision" },
    { label: "EN Dub", key: "en_dub" },
    { label: "FR Dub", key: "fr_dub" },
    { label: "Comments", key: "comment" },
    { label: "CreatedAt", key: "created_at" },
];

export const getData = (data) => {
    const animeData = [
        {
            en_title: data?.en_title,
            universe_name: data?.universe_name,
            licensor: data?.licensor,
            studio: data?.studio,
            studio_link: data?.studio_link,
            no_of_episodes: data?.no_of_episodes,
            platforms: data?.platforms,
            ratings: data?.ratings,
            vod_link: data?.vod_link,
            rel_date: data?.rel_date,
            rel_date_precision: data?.rel_date_precision,
            en_dub: data?.en_dub,
            fr_dub: data?.fr_dub,
            comment: data?.comment,
            created_at: moment(data?.created_at).format("YYYY-MM-DD HH:mm:ss"),
        },
    ];

    return animeData;
};

function ViewAnime() {
    const { state } = useLocation();
    const { id: view_anime_id } = useParams();
    const [params] = useSearchParams();
    const [anime, setAnime] = useState(state?.row ? state.row : null);
    const [currentComment, setCurrentComment] = useState(state?.row?.comment || "");
    const [permissions, setPermissions] = useState([]);
    const [universeSummaryData, setUniverseSummaryData] = useState([]);
    const [openUniverseModel, setOpenUniverseModel] = useState(false);
    const [csvData, setCsvData] = useState([]);

    const navigate = useNavigate();
    const { confirm } = Modal;
    const animeId = view_anime_id;

    const handleDeleteAnimeComment = async () => {
        try {
            const response = await deleteAnimeComment(animeId);
            if (response.isSuccess) {
                toast.success(`${response.message}`);
                setCurrentComment("");
            }
        } catch (error) {
            toast.error(`${error.message}`);
        }
    };

    const fetchUniverseDetail = async (universeId) => {
        setOpenUniverseModel(true);
        const res = await getUniverseSummaryById(universeId);
        if (res && res.isSuccess) {
            setUniverseSummaryData(res.data);
        }
    };

    const fetchAnimeDetail = async () => {
        try {
            const response = await getAnimeById({
                anime_id: view_anime_id,
            });
            if (response && response.isSuccess) {
                setAnime(response.data);
                setCurrentComment(response.data.comment || "");
                setCsvData(getData(response.data));
            }
        } catch (error) {
            toast.error(`${error.message}`);
        }
    };

    useEffect(() => {
        // console.log(state?.row)
        // if (!state?.row) {
        //     fetchAnimeDetail();
        // } else {
        //     setCsvData(getData(state.row));
        // }
        fetchAnimeDetail();
    }, [view_anime_id]);

    useEffect(() => {
        const loginData = JSON.parse(localStorage.getItem("User"));
        if (loginData) {
            setPermissions(loginData.permissions);
        }
    }, []);

    const showDeleteConfirm = () => {
        confirm({
            title: "Are you sure delete this comment ?",
            icon: <ExclamationCircleFilled />,
            okText: "Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk() {
                handleDeleteAnimeComment();
            },
        });
    };

    const formatRelDate = (date, precision) => {
        if (!date) return "";
        const d = moment(date);
        switch (precision) {
            case "MONTH_YEAR":
                return d.format("MMM YYYY");
            case "QUARTER_YEAR":
                const quarter = Math.floor(d.month() / 3) + 1;
                return `Q${quarter} ${d.year()}`;
            case "YEAR_ONLY":
                return d.format("YYYY");
            case "EXACT":
            default:
                return d.format("YYYY-MM-DD");
        }
    };

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <Card>
                    <Row>
                        <Col lg="12">
                            <Card className="shadow m-4 detail_card ">
                                <CardHeader className="border-0">
                                    <Row>
                                        <Col lg="6">
                                            <h1 className="mb-0">Anime Detail</h1>
                                        </Col>
                                        <Col lg="6" className="text-right">
                                            {permissions.includes("update-anime") && (
                                                <Button
                                                    color="primary"
                                                    onClick={() => navigate(`/admin/anime/update-anime/${animeId}`, { state: { row: anime } })}
                                                >
                                                    Edit
                                                </Button>
                                            )}
                                            <CSVLink
                                                data={csvData}
                                                headers={headers}
                                                filename={genrateCsvFileName(`anime_${anime?.en_title}`)}
                                                className="btn btn-primary ml-2"
                                                target="_blank"
                                            >
                                                Export to CSV
                                            </CSVLink>
                                            <Button
                                                color="primary"
                                                className="ml-2"
                                                onClick={() => navigate("/admin/anime/anime-list")}
                                            >
                                                Back
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col lg="6">
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">EN Title</Col>
                                                <Col lg="8">{anime?.en_title}</Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">Universe</Col>
                                                <Col lg="8">
                                                    <span
                                                        className="primary-text-color"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => fetchUniverseDetail(anime?.universe_id)}
                                                    >
                                                        {anime?.universe_name}
                                                    </span>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">JP Publisher</Col>
                                                <Col lg="8">{anime?.licensor}</Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">Studio</Col>
                                                <Col lg="8">{anime?.studio}</Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">Studio Link</Col>
                                                <Col lg="8">
                                                    <a href={anime?.studio_link} target="_blank" rel="noreferrer" className="primary-text-color">
                                                        {anime?.studio_link}
                                                    </a>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg="6">
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">Rel. Date</Col>
                                                <Col lg="8">{formatRelDate(anime?.rel_date, anime?.rel_date_precision)}</Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">Episodes</Col>
                                                <Col lg="8">{anime?.no_of_episodes}</Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">VoD in France</Col>
                                                <Col lg="8">{anime?.platforms}</Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">VoD Link</Col>
                                                <Col lg="8">
                                                    <a href={anime?.vod_link} target="_blank" rel="noreferrer" className="primary-text-color">
                                                        {anime?.vod_link}
                                                    </a>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">EN Dub</Col>
                                                <Col lg="8">{anime?.en_dub}</Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="4" className="font-weight-bold">FR Dub</Col>
                                                <Col lg="8">{anime?.fr_dub}</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col lg="12">
                                            <Row className="mb-3">
                                                <Col lg="2" className="font-weight-bold">Ratings</Col>
                                                <Col lg="10">{anime?.ratings}</Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col lg="2" className="font-weight-bold">Comments</Col>
                                                <Col lg="10">
                                                    <div className="border p-2 bg-light" style={{ minHeight: "100px", whiteSpace: "pre-wrap" }}>
                                                        {currentComment}
                                                    </div>
                                                    {permissions.includes("update-anime") && currentComment && (
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            className="mt-2"
                                                            onClick={showDeleteConfirm}
                                                        >
                                                            Delete Comment
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Card>
            </Container>
            <UniverseModal
                openUniverseModel={openUniverseModel}
                setOpenUniverseModel={setOpenUniverseModel}
                universeSummaryData={universeSummaryData}
            />
        </>
    );
}

export default ViewAnime;
